import { render, staticRenderFns } from "./SwitchHold.vue?vue&type=template&id=7b74dade&scoped=true"
import script from "./SwitchHold.vue?vue&type=script&lang=js"
export * from "./SwitchHold.vue?vue&type=script&lang=js"
import style0 from "./SwitchHold.vue?vue&type=style&index=0&id=7b74dade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b74dade",
  null
  
)

export default component.exports